module.exports = __webpack_public_path__ + "img/tu01.0ba1a15f.png";